<!-- xlsx.js (C) 2013-present  SheetJS -- http://sheetjs.com -->
<template>
    <div @drop="_drop" @dragenter="_suppress" @dragover="_suppress">
        <div class="row">
            <div class="col-xs-12">
                <form class="form-inline">
                    <div class="form-group">
                        <label for="file">Spreadsheet</label>
                        <input
                            type="file"
                            class="form-control"
                            id="file"
                            :accept="SheetJSFT"
                            @change="_change"
                        />
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <button
                    :disabled="data.length ? false : true"
                    class="btn btn-success"
                    @click="export3"
                >
                    Export
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th v-for="c in cols" :key="c.key">
                                    {{ c.name }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(r, key) in data" :key="key">
                                <td v-for="c in cols" :key="c.key">
                                    {{ r[c.key] }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint no-unused-vars: 'off', comma-style: 'off', dot-notation: 'off' */
//Fix for using xlsx-style.  However, it still doesn't work
import XLSX from 'xlsx';
//import XLSXSTYLE from 'xlsx-style';
//import XLSXSTYLE from 'msexcel-builder';

const makeCols = (refstr) =>
    Array(XLSXSTYLE.utils.decode_range(refstr).e.c + 1)
        .fill(0)
        .map((x, i) => ({ name: XLSXSTYLE.utils.encode_col(i), key: i }));

const _SheetJSFT = [
    'xlsx',
    'xlsb',
    'xlsm',
    'xls',
    'xml',
    'csv',
    'txt',
    'ods',
    'fods',
    'uos',
    'sylk',
    'dif',
    'dbf',
    'prn',
    'qpw',
    '123',
    'wb*',
    'wq*',
    'html',
    'htm'
]
    .map(function (x) {
        return '.' + x;
    })
    .join(',');
export default {
    data() {
        return {
            data: ['SheetJS'.split(''), '1234567'.split('')],
            cols: [
                { name: 'A', key: 0 },
                { name: 'B', key: 1 },
                { name: 'C', key: 2 },
                { name: 'D', key: 3 },
                { name: 'E', key: 4 },
                { name: 'F', key: 5 },
                { name: 'G', key: 6 }
            ],
            SheetJSFT: _SheetJSFT
        };
    },
    methods: {
        export3: function () {
            //if (typeof console === 'undefined')
            //  console = { log: function () { } };

            var ext = typeof process !== 'undefined' && !!process.argv[2];

            /* original data */
            var data = [
                [1, 2, 3],
                [true, false, null, 'sheetjs'],
                ['foo    bar', 'baz', new Date('2014-02-19T14:30Z'), '0.3'],
                ['baz', null, '\u0BEE', 3.14159],
                ['hidden'],
                ['visible']
            ];

            if (isNaN(data[2][2].getYear()))
                data[2][2] = new Date(Date.UTC(2014, 1, 19, 14, 30, 0));

            var workSheetName = 'SheetJS';

            var wscols = [
                { wch: 6 }, // 'characters'
                { wpx: 100 }, // 'pixels'
                ,
                { hidden: true } // hide column
            ];

            /* At 96 PPI, 1 pt = 1 px */
            var wsrows = [
                { hpt: 12 }, // 'points'
                { hpx: 16 }, // 'pixels'
                ,
                { hpx: 24, level: 3 },
                { hidden: true }, // hide row
                { hidden: false }
            ];

            var wb = XLSXSTYLE.utils.book_new();
            /* convert an array of arrays in JS to a CSF spreadsheet */
            var ws = XLSXSTYLE.utils.aoa_to_sheet(data, { cellDates: true });

            /* TEST: column props */
            ws['!cols'] = wscols;

            /* TEST: row props */
            ws['!rows'] = wsrows;
            ws['A1'] = {
                v: 'Abcd',
                s: {
                    alignment: { textRotation: 90 },
                    font: { sz: 14, bold: true }
                    //font: { sz: 14, bold: true, color: '#FF00FF' }
                }
            };
            XLSXSTYLE.utils.book_append_sheet(wb, ws, workSheetName);
            XLSXSTYLE.writeFile(wb, 'sheetjs.xlsx');
        },
        export2: function () {
            //if (typeof console === 'undefined')
            //  console = { log: function () { } };

            var ext = typeof process !== 'undefined' && !!process.argv[2];

            /* original data */
            var data = [
                [1, 2, 3],
                [true, false, null, 'sheetjs'],
                ['foo    bar', 'baz', new Date('2014-02-19T14:30Z'), '0.3'],
                ['baz', null, '\u0BEE', 3.14159],
                ['hidden'],
                ['visible']
            ];
            if (isNaN(data[2][2].getYear()))
                data[2][2] = new Date(Date.UTC(2014, 1, 19, 14, 30, 0));

            var workSheetName = 'SheetJS';

            var wscols = [
                { wch: 6 }, // 'characters'
                { wpx: 50 }, // 'pixels'
                ,
                { hidden: true } // hide column
            ];

            /* At 96 PPI, 1 pt = 1 px */
            var wsrows = [
                { hpt: 12 }, // 'points'
                { hpx: 16 }, // 'pixels'
                ,
                { hpx: 24, level: 3 },
                { hidden: true }, // hide row
                { hidden: false }
            ];

            /* blank workbook constructor */
            /*
        var wb = { SheetNames: [], Sheets: {} };
        */
            var wb = XLSXSTYLE.utils.book_new();
            /* convert an array of arrays in JS to a CSF spreadsheet */
            var ws = XLSXSTYLE.utils.aoa_to_sheet(data, { cellDates: true });
            //Formatting not working
            //ws['A1'] = {
            //  v: 'Abcd',
            //  s: {
            //    alignment: { textRotation: 90 },
            //    font: { sz: 14, bold: true, color: '#FF00FF' }
            //  }
            //};

            /* TEST: add worksheet to workbook */
            /*
        wb.SheetNames.push(workSheetName);
        wb.Sheets[workSheetName] = ws;
        */
            XLSXSTYLE.utils.book_append_sheet(wb, ws, workSheetName);

            /* TEST: simple formula */
            ws['C1'].f = 'A1+B1';
            ws['C2'] = { t: 'n', f: 'A1+B1' };

            XLSXSTYLE.utils.sheet_set_array_formula(
                ws,
                'D1:D1',
                'SUM(A1:C1*A1:C1)'
            );

            XLSXSTYLE.utils.sheet_set_array_formula(
                ws,
                'E1:E4',
                'TRANSPOSE(A1:D1)'
            );
            ws['!ref'] = 'A1:E6';

            /* TEST: column props */
            ws['!cols'] = wscols;

            /* TEST: row props */
            ws['!rows'] = wsrows;

            /* TEST: hyperlink note: Excel does not automatically style hyperlinks */
            /*
        ws['A4'].l = { Target: '#E2' };
        */
            XLSXSTYLE.utils.cell_set_internal_link(ws['A4'], 'E2');
            /*
        ws['A3'].l = { Target: 'http://sheetjs.com', Tooltip: 'Visit us <SheetJS.com!>' };
        */
            XLSXSTYLE.utils.cell_set_hyperlink(
                ws['A3'],
                'http://sheetjs.com',
                'Visit us <SheetJS.com!>'
            );

            /* TEST: built-in format */
            /*
        ws['B1'].z = '0%'; // Format Code 9
        */
            XLSXSTYLE.utils.cell_set_number_format(ws['B1'], '0%');

            /* TEST: custom format */
            var custfmt = "'This is '\\ 0.0";
            /*
        ws['C2'].z = custfmt;
        */
            XLSXSTYLE.utils.cell_set_number_format(ws['C2'], custfmt);

            /* TEST: page margins */
            ws['!margins'] = {
                left: 1.0,
                right: 1.0,
                top: 1.0,
                bottom: 1.0,
                header: 0.5,
                footer: 0.5
            };

            /* TEST: merge cells */
            ws['!merges'] = [XLSXSTYLE.utils.decode_range('A6:C6')];

            /* TEST: hidden sheets */
            /*
        wb.SheetNames.push('Hidden');
        wb.Sheets['Hidden'] = XLSXSTYLE.utils.aoa_to_sheet(['Hidden'.split(''), [1,2,3]]);
        wb.Workbook = {Sheets:[]};
        wb.Workbook.Sheets[1] = {Hidden:1};
        */
            var data2 = [
                'Hidden'.split(''),
                [1, true, 3, 'a', , 'c'],
                [2, false, true, 'sh33t', , 'j5']
            ];
            XLSXSTYLE.utils.book_append_sheet(
                wb,
                XLSXSTYLE.utils.aoa_to_sheet(data2),
                'Hidden'
            );

            XLSXSTYLE.utils.book_set_sheet_visibility(
                wb,
                'Hidden',
                XLSXSTYLE.utils.consts.SHEET_HIDDEN
            );

            /* TEST: properties */
            wb.Props = {
                Title: 'SheetJS Test',
                Subject: 'Tests',
                Author: 'Devs at SheetJS',
                Manager: 'Sheet Manager',
                Company: 'SheetJS',
                Category: 'Experimentation',
                Keywords: 'Test',
                Comments: 'Nothing to say here',
                LastAuthor: 'Not SheetJS',
                CreatedDate: new Date(2017, 1, 19)
            };

            XLSXSTYLE.utils.cell_add_comment(
                ws['A4'],
                'Im a little comment, short and stout!\n\nWell, Stout may be the wrong word',
                'SheetJS'
            );

            /* TEST: sheet protection */
            ws['!protect'] = {
                password: 'password',
                /* enable formatting rows and columns */
                formatRows: false,
                formatColumns: false,
                /* disable editing objects and scenarios */
                objects: true,
                scenarios: true
            };

            /* TEST: Workbook Properties */
            if (wb.Workbook === undefined)
                wb.Workbook = { Sheets: [], WBProps: {} };
            if (wb.Workbook.WBProps === undefined) wb.Workbook.WBProps = {};
            wb.Workbook.WBProps.filterPrivacy = true;
            if (ext) wb.Workbook.Views = [{ RTL: true }];

            XLSXSTYLE.writeFile(wb, 'sheetjs.xlsx', { bookSST: true });
        },
        _suppress(evt) {
            evt.stopPropagation();
            evt.preventDefault();
        },
        _drop(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            const files = evt.dataTransfer.files;
            if (files && files[0]) this._file(files[0]);
        },
        _change(evt) {
            const files = evt.target.files;
            if (files && files[0]) this._file(files[0]);
        },
        _export(evt) {
            /* convert state to workbook */
            const ws = XLSXSTYLE.utils.aoa_to_sheet(this.data);
            const ws2 = XLSXSTYLE.utils.aoa_to_sheet(this.data);
            const wb = XLSXSTYLE.utils.book_new();

            XLSXSTYLE.utils.book_append_sheet(wb, ws, 'SheetJS');
            XLSXSTYLE.utils.book_append_sheet(wb, ws2, 'SheetJS3');
            /* generate file and send to client */
            XLSXSTYLE.writeFile(wb, 'sheetjs.xlsx');
        },
        _file(file) {
            /* Boilerplate to set up FileReader */
            const reader = new FileReader();
            reader.onload = (e) => {
                /* Parse data */
                const bstr = e.target.result;
                const wb = XLSXSTYLE.read(bstr, { type: 'binary' });
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                const data = XLSXSTYLE.utils.sheet_to_json(ws, { header: 1 });
                /* Update state */
                this.data = data;
                this.cols = makeCols(ws['!ref']);
            };
            reader.readAsBinaryString(file);
        }
    }
};
</script>
